// import React, { useState, useRef, useEffect } from "react";
// import {
//   motion,
//   useScroll,
//   useTransform,
//   useMotionValue,
//   useMotionTemplate,
// } from "motion/react";

// export function Slider() {
//   const sectionRef = useRef(null);
//   const containerRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: sectionRef,
//     offset: ["start end", "end start"],
//   });

//   const scrollPosition = useTransform(scrollYProgress, [0.2, 0.8], [10, 90]);
//   const sliderPosition = useMotionValue(50);
//   const [isDragging, setIsDragging] = useState(false);
//   const [activeSide, setActiveSide] = useState("calm"); // "chaos" or "calm"

//   // Use scroll position when not dragging
//   useEffect(() => {
//     if (!isDragging) {
//       const unsubscribe = scrollPosition.on("change", (latest) => {
//         sliderPosition.set(latest);
//         // Determine which side is active based on slider position
//         if (latest > 50) {
//           setActiveSide("calm");
//         } else {
//           setActiveSide("chaos");
//         }
//       });
//       return unsubscribe;
//     }
//   }, [isDragging, scrollPosition, sliderPosition]);

//   const isMobile = typeof window !== "undefined" && window.innerWidth < 768;

//   // UPDATED: Improved drag handler for mobile
//   const handleDrag = (event, info) => {
//     const container = containerRef.current;
//     if (!container) return;

//     const rect = container.getBoundingClientRect();

//     if (isMobile) {
//       // MOBILE — vertical slider with better calculation
//       const mouseY = info.point.y;
//       // UPDATED: Better percentage calculation for mobile
//       const percentage = ((mouseY - rect.top) / rect.height) * 100;
//       const newPosition = Math.max(5, Math.min(95, percentage)); // UPDATED: Added bounds
//       sliderPosition.set(newPosition);

//       // Determine active side based on position
//       if (newPosition > 50) {
//         setActiveSide("calm");
//       } else {
//         setActiveSide("chaos");
//       }
//     } else {
//       // DESKTOP — horizontal slider
//       const mouseX = info.point.x;
//       const percentage = ((mouseX - rect.left) / rect.width) * 100;
//       const newPosition = Math.max(0, Math.min(100, percentage));
//       sliderPosition.set(newPosition);

//       // Determine active side based on position
//       if (newPosition > 50) {
//         setActiveSide("calm");
//       } else {
//         setActiveSide("chaos");
//       }
//     }
//   };

//   // UPDATED: Better drag constraints for mobile
//   const getDragConstraints = () => {
//     if (isMobile) {
//       // Mobile: Allow vertical drag within container bounds
//       return { top: -350, bottom: 350 };
//     } else {
//       // Desktop: Use container ref for horizontal constraints
//       return containerRef;
//     }
//   };

//   return (
//     <section ref={sectionRef} className="py-16 md:py-32 px-5 bg-white">
//       <div className="max-w-[1400px] mx-auto">
//         {/* Header */}
//         <motion.div
//           className="text-center mb-10 md:mb-20"
//           initial={{ opacity: 0, y: 30 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           viewport={{ once: true }}
//           transition={{ duration: 0.6 }}
//         >
//           <h2 className="text-[--color-primary] mb-6">
//             The difference is night and day.
//           </h2>
//           <p className="text-[--color-text-secondary]">
//             See how Simplifyte transforms chaotic workflows into calm productivity.
//           </p>
//         </motion.div>

//         {/* Comparison Container */}
//         <motion.div
//           ref={containerRef}
//           className="relative rounded-3xl overflow-hidden Slider_Container"
//           style={{ boxShadow: "0 30px 100px rgba(0, 0, 0, 0.2)" }}
//           initial={{ opacity: 0, scale: 0.95 }}
//           whileInView={{ opacity: 1, scale: 1 }}
//           viewport={{ once: true }}
//           transition={{ duration: 0.8, delay: 0.2 }}
//         >
//           {/* Before Side (CHAOS) - Only show when active */}
//           <motion.div
//             className="absolute inset-0 bg-[linear-gradient(135deg,#1a0a0f_0%,#2d1520_50%,#1a0a0f_100%)] flex items-center justify-center"
//             animate={{
//               opacity: activeSide === "chaos" ? 1 : 0,
//               scale: activeSide === "chaos" ? 1 : 0.95
//             }}
//             transition={{ duration: 0.3 }}
//           >
//             <ChaosSide />
//           </motion.div>

//           {/* After Side (CALM) - Only show when active */}
//           <motion.div
//             className="absolute inset-0 bg-[linear-gradient(135deg,#093A5B_0%,#0a4d6e_50%,#093A5B_100%)] flex items-center justify-center"
//             animate={{
//               opacity: activeSide === "calm" ? 1 : 0,
//               scale: activeSide === "calm" ? 1 : 0.95
//             }}
//             transition={{ duration: 0.3 }}
//           >
//             <CalmSide />
//           </motion.div>

//           {/* Slider Indicator */}
//           <motion.div
//             className={`absolute z-20 ${isMobile ? "left-0 right-0 h-0" : "top-0 bottom-0 w-0"}`}
//             style={
//               isMobile
//                 ? { top: useMotionTemplate`${sliderPosition}%` }
//                 : { left: useMotionTemplate`${sliderPosition}%` }
//             }
//           >
//             {/* Slider Line */}
//             <div
//               className={`absolute bg-white ${isMobile
//                 ? "left-0 right-0 top-1/2 -translate-y-1/2 h-[2px]"
//                 : "top-0 bottom-0 left-1/2 -translate-x-1/2 w-[2px]"
//                 }`}
//               style={{
//                 boxShadow: "0 0 30px rgba(255, 255, 255, 0.8)",
//               }}
//             />

//             {/* UPDATED: Circular Handle with better mobile support */}
//             <motion.div
//               className="
//                 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2
//                 w-20 h-20 bg-white rounded-full shadow-2xl
//                 flex items-center justify-center
//                 cursor-grab active:cursor-grabbing
//                 touch-none /* UPDATED: Added for better mobile touch */
//               "
//               drag={isMobile ? "y" : "x"}
//               // UPDATED: Better drag constraints for mobile
//               dragConstraints={getDragConstraints()}
//               dragElastic={0}
//               dragMomentum={false}
//               onDragStart={() => setIsDragging(true)}
//               onDragEnd={() => setIsDragging(false)}
//               onDrag={handleDrag}
//               whileHover={{ scale: 1.1 }}
//               whileTap={{ scale: 0.95 }}
//             >
//               {/* Dynamic arrows based on orientation */}
//               <svg
//                 width="28"
//                 height="28"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 stroke="currentColor"
//                 strokeWidth="2.5"
//                 className="text-[--color-primary]"
//                 style={{
//                   transform: isMobile ? "rotate(90deg)" : "none"
//                 }}
//               >
//                 <path d="M18 8L22 12L18 16" />
//                 <path d="M6 8L2 12L6 16" />
//               </svg>

//               {/* UPDATED: Better mobile positioning for hint text */}
//               <motion.div
//                 className="
//                   absolute bg-white px-4 py-2 rounded-full shadow-lg
//                   whitespace-nowrap pointer-events-none
//                   z-30 /* UPDATED: Ensure it's above other elements */
//                 "
//                 style={{
//                   fontSize: "0.875rem",
//                   fontWeight: 500,
//                   color: "#093A5B",
//                   // UPDATED: Better mobile positioning
//                   ...(isMobile
//                     ? {
//                       left: '50%',
//                       top: '-5rem', /* UPDATED: Moved further up for mobile */
//                       transform: 'translateX(-50%)',
//                       textAlign: 'center'
//                     }
//                     : {
//                       top: '50%',
//                       left: '-8rem',
//                       transform: 'translateY(-50%)'
//                     }
//                   )
//                 }}
//                 initial={{ opacity: 1 }}
//                 animate={{ opacity: isDragging ? 0 : [1, 0.5, 1] }}
//                 transition={{ duration: 2, repeat: isDragging ? 0 : Infinity }}
//               >
//                 {isMobile ? "↑ Drag to compare ↓" : "← Drag to compare →"}
//               </motion.div>
//             </motion.div>
//           </motion.div>

//           {/* Side Indicators */}
//           <div className="absolute bottom-6 left-6 z-10">
//             <motion.div
//               className="bg-black/30 backdrop-blur-sm rounded-full px-4 py-2 border border-white/20"
//               animate={{
//                 opacity: activeSide === "chaos" ? 1 : 0.5,
//                 scale: activeSide === "chaos" ? 1.05 : 1
//               }}
//               transition={{ duration: 0.3 }}
//             >
//               <span className="text-red-300 font-semibold text-sm">CHAOS</span>
//             </motion.div>
//           </div>

//           <div className="absolute bottom-6 right-6 z-10">
//             <motion.div
//               className="bg-black/30 backdrop-blur-sm rounded-full px-4 py-2 border border-white/20"
//               animate={{
//                 opacity: activeSide === "calm" ? 1 : 0.5,
//                 scale: activeSide === "calm" ? 1.05 : 1
//               }}
//               transition={{ duration: 0.3 }}
//             >
//               <span className="text-teal-300 font-semibold text-sm">CALM</span>
//             </motion.div>
//           </div>
//         </motion.div>
//       </div>
//     </section>
//   );
// }

// // CHAOS SIDE - Centered content (unchanged)
// function ChaosSide() {
//   const chaosElements = [
//     { icon: "📧", text: "URGENT!!!", x: 10, y: 12, rotation: -12 },
//     { icon: "💬", text: "47 unread", x: 70, y: 18, rotation: 8 },
//     { icon: "📁", text: "Where?", x: 12, y: 75, rotation: 15 },
//     { icon: "❓", text: "Lost file", x: 75, y: 70, rotation: -18 },
//     { icon: "📱", text: "+99", x: 40, y: 85, rotation: 5 },
//   ];

//   return (
//     <div className="relative w-full h-full flex items-center justify-center px-4 md:px-16">
//       {/* Noise */}
//       <motion.div
//         className="absolute inset-0 opacity-10"
//         style={{
//           backgroundImage:
//             "repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(255,255,255,0.03) 2px, rgba(255,255,255,0.03) 4px)",
//         }}
//         animate={{ backgroundPosition: ["0px 0px", "0px 100px"] }}
//         transition={{ duration: 3, repeat: Infinity, ease: "linear" }}
//       />

//       {/* Floating Chaos Elements */}
//       <div className="absolute inset-0 pointer-events-none">
//         {chaosElements.map((el, idx) => (
//           <motion.div
//             key={idx}
//             className="absolute bg-red-900/30 backdrop-blur-sm border border-red-500/40 rounded-xl p-3"
//             style={{
//               left: `${el.x}%`,
//               top: `${el.y}%`,
//             }}
//             animate={{
//               y: [0, -15, 0],
//               rotate: [el.rotation, el.rotation + 8, el.rotation],
//               opacity: [0.5, 0.8, 0.5],
//             }}
//             transition={{
//               duration: 2.5 + idx * 0.5,
//               repeat: Infinity,
//               ease: "easeInOut",
//             }}
//           >
//             <div className="flex items-center gap-2">
//               <span style={{ fontSize: "1.25rem" }}>{el.icon}</span>
//               <span
//                 className="text-red-300 whitespace-nowrap"
//                 style={{ fontSize: "0.8125rem", fontWeight: 600 }}
//               >
//                 {el.text}
//               </span>
//             </div>
//           </motion.div>
//         ))}
//       </div>

//       {/* Centered Content */}
//       <div className="relative z-10 w-full max-w-sm text-center">
//         <motion.div
//           className="mb-6"
//           animate={{ opacity: [1, 0.7, 1] }}
//           transition={{ duration: 2, repeat: Infinity }}
//         >
//           <div className="flex flex-row justify-center items-center">
//             <div
//               className="text-red-400 mb-4"
//               style={{
//                 fontSize: "1.25rem",
//                 fontWeight: 700,
//                 letterSpacing: "0.12em",
//               }}
//             >
//               THE OLD WAY
//             </div>
//             <div
//               className="text-red-200/60 mb-2"
//               style={{ fontSize: "3.5rem", fontWeight: 300, lineHeight: 1 }}
//             >
//               😵‍💫
//             </div>
//           </div>
//         </motion.div>

//         <div className="bg-black/20 backdrop-blur-sm rounded-xl p-5 border border-red-900/30 mx-auto">
//           <div className="space-y-2.5">
//             {/* Browser Tabs */}
//             <div className="flex gap-1 mb-3 overflow-hidden">
//               {Array.from({ length: 8 }).map((_, i) => (
//                 <motion.div
//                   key={i}
//                   className="h-7 bg-red-900/40 rounded-t flex-1 min-w-0"
//                   animate={{ opacity: [0.3, 0.6, 0.3] }}
//                   transition={{ duration: 1 + i * 0.15, repeat: Infinity }}
//                 />
//               ))}
//             </div>

//             {/* Items */}
//             {[
//               "Multiple apps open",
//               "Lost in threads",
//               "Can't find files",
//               "Working late",
//             ].map((text, i) => (
//               <motion.div
//                 key={i}
//                 className="bg-red-900/20 rounded p-2.5 border-l-2 border-red-500"
//                 animate={{ x: [-1.5, 1.5, -1.5] }}
//                 transition={{ duration: 1.5 + i * 0.25, repeat: Infinity }}
//               >
//                 <div
//                   className="text-red-200/50"
//                   style={{ fontSize: "0.75rem" }}
//                 >
//                   {text}
//                 </div>
//               </motion.div>
//             ))}
//           </div>

//           <motion.div
//             className="mt-5 text-red-400 flex items-center justify-center gap-2"
//             style={{ fontSize: "0.8125rem", fontWeight: 600 }}
//             animate={{ opacity: [1, 0.5, 1] }}
//             transition={{ duration: 1.5, repeat: Infinity }}
//           >
//             <span>🕘</span>
//             <span>Still working at 9:30 PM</span>
//           </motion.div>
//         </div>
//       </div>
//     </div>
//   );
// }

// // CALM SIDE - Centered content (unchanged)
// function CalmSide() {
//   return (
//     <div className="relative w-full h-full flex items-center justify-center px-4 md:px-16">
//       {/* Grid Pattern */}
//       <div
//         className="absolute inset-0 opacity-5"
//         style={{
//           backgroundImage: `radial-gradient(circle, rgba(255, 255, 255, 0.3) 1px, transparent 1px)`,
//           backgroundSize: "30px 30px",
//         }}
//       />

//       {/* Centered Content */}
//       <div className="relative z-10 w-full max-w-sm text-center">
//         <motion.div
//           className="mb-6"
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.8 }}
//         >
//           <div className="flex flex-row justify-center items-center">
//             <div
//               className=" text-teal-300 mb-4 Simplifyte_Title"
//             // style={{
//             //   fontSize: "1.25rem",
//             //   fontWeight: 700,
//             //   letterSpacing: "0.12em",
//             // }}
//             >
//               THE SIMPLIFYTE WAY
//             </div>
//             <div
//               className="text-teal-100 mb-2 Simplifyte_Emoji"
//             // style={{ fontSize: "3.5rem", fontWeight: 300, lineHeight: 1 }}
//             >
//               ✨
//             </div>
//           </div>
//         </motion.div>

//         <div
//           className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20 mx-auto"
//           style={{ boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)" }}
//         >
//           <div className="space-y-3.5">
//             {[
//               { icon: "✅", text: "All tasks in one view" },
//               { icon: "💬", text: "Conversations in context" },
//               { icon: "📎", text: "Files where you need them" },
//               { icon: "🎯", text: "Everything organized" },
//             ].map((item, i) => (
//               <motion.div
//                 key={i}
//                 className="bg-white/10 rounded-xl p-3.5 border border-white/10 flex items-center gap-3"
//                 initial={{ opacity: 0, x: -20 }}
//                 whileInView={{ opacity: 1, x: 0 }}
//                 viewport={{ once: true }}
//                 transition={{ delay: i * 0.1, duration: 0.5 }}
//               >
//                 <span style={{ fontSize: "1.125rem" }}>{item.icon}</span>
//                 <span
//                   className="text-white/90"
//                   style={{ fontSize: "0.875rem" }}
//                 >
//                   {item.text}
//                 </span>
//               </motion.div>
//             ))}
//           </div>

//           <motion.div
//             className="mt-5 text-teal-300 flex items-center justify-center gap-2"
//             style={{ fontSize: "0.9375rem", fontWeight: 600 }}
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             transition={{ delay: 0.8 }}
//           >
//             <span>🏡</span>
//             <span>Home by 6:00 PM</span>
//           </motion.div>
//         </div>
//       </div>
//     </div>
//   );
// }



// 2 Second Code is there =====================================
// import React, { useState, useRef, useEffect } from "react";
// import {
//   motion,
//   useScroll,
//   useTransform,
//   useMotionValue,
//   useMotionTemplate,
// } from "motion/react";

// export function Slider() {
//   const sectionRef = useRef(null);
//   const containerRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: sectionRef,
//     offset: ["start end", "end start"],
//   });

//   const scrollPosition = useTransform(scrollYProgress, [0.2, 0.8], [10, 90]);

//   const sliderPosition = useMotionValue(50);
//   const [isDragging, setIsDragging] = useState(false);
//   const [activeSide, setActiveSide] = useState("calm"); // "chaos" or "calm"

//   const isMobile =
//     typeof window !== "undefined" && window.innerWidth < 768;

//   // Derived motion values for clipping both sides
//   const chaosSize = useTransform(sliderPosition, (v) => v); // %
//   const calmSize = useTransform(sliderPosition, (v) => 100 - v); // %
//   const sliderPosTemplate = useMotionTemplate`${sliderPosition}%`;
//   const chaosSizeTemplate = useMotionTemplate`${chaosSize}%`;
//   const calmSizeTemplate = useMotionTemplate`${calmSize}%`;

//   // Use scroll position when not dragging
//   useEffect(() => {
//     if (!isDragging) {
//       const unsubscribe = scrollPosition.on("change", (latest) => {
//         sliderPosition.set(latest);
//         // Determine which side feels "active" (for badges)
//         setActiveSide(latest > 50 ? "calm" : "chaos");
//       });
//       return unsubscribe;
//     }
//   }, [isDragging, scrollPosition, sliderPosition]);

//   // Drag handler for slider
//   const handleDrag = (event, info) => {
//     const container = containerRef.current;
//     if (!container) return;

//     const rect = container.getBoundingClientRect();

//     if (isMobile) {
//       // MOBILE — vertical slider (top vs bottom)
//       const mouseY = info.point.y;
//       const percentage = ((mouseY - rect.top) / rect.height) * 100;
//       const newPosition = Math.max(5, Math.min(95, percentage));
//       sliderPosition.set(newPosition);
//       setActiveSide(newPosition > 50 ? "calm" : "chaos");
//     } else {
//       // DESKTOP — horizontal slider (left vs right)
//       const mouseX = info.point.x;
//       const percentage = ((mouseX - rect.left) / rect.width) * 100;
//       const newPosition = Math.max(0, Math.min(100, percentage));
//       sliderPosition.set(newPosition);
//       setActiveSide(newPosition > 50 ? "calm" : "chaos");
//     }
//   };

//   const getDragConstraints = () => {
//     if (isMobile) {
//       // Mobile: Allow vertical drag within container bounds
//       return { top: -350, bottom: 350 };
//     } else {
//       // Desktop: Use container ref for horizontal constraints
//       return containerRef;
//     }
//   };

//   return (
//     <section ref={sectionRef} className="py-16 md:py-32 px-5 bg-white">
//       <div className="max-w-[1400px] mx-auto">
//         {/* Header */}
//         <motion.div
//           className="text-center mb-10 md:mb-20"
//           initial={{ opacity: 0, y: 30 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           viewport={{ once: true }}
//           transition={{ duration: 0.6 }}
//         >
//           <h2 className="text-[--color-primary] mb-6">
//             The difference is night and day.
//           </h2>
//           <p className="text-[--color-text-secondary]">
//             See how Simplifyte transforms chaotic workflows into calm
//             productivity.
//           </p>
//         </motion.div>

//         {/* Comparison Container */}
//         <motion.div
//           ref={containerRef}
//           className="relative rounded-3xl overflow-hidden Slider_Container"
//           style={{ boxShadow: "0 30px 100px rgba(0, 0, 0, 0.2)" }}
//           initial={{ opacity: 0, scale: 0.95 }}
//           whileInView={{ opacity: 1, scale: 1 }}
//           viewport={{ once: true }}
//           transition={{ duration: 0.8, delay: 0.2 }}
//         >
//           {/* CHAOS (left / top) */}
//           <motion.div
//             className="absolute inset-0 bg-[linear-gradient(135deg,#1a0a0f_0%,#2d1520_50%,#1a0a0f_100%)] flex items-center justify-center"
//             style={
//               isMobile
//                 ? { top: 0, height: chaosSizeTemplate, overflow: "hidden" }
//                 : { left: 0, width: chaosSizeTemplate, overflow: "hidden" }
//             }
//           >
//             <ChaosSide />
//           </motion.div>

//           {/* CALM (right / bottom) */}
//           <motion.div
//             className="absolute inset-0 bg-[linear-gradient(135deg,#093A5B_0%,#0a4d6e_50%,#093A5B_100%)] flex items-center justify-center"
//             style={
//               isMobile
//                 ? {
//                   top: sliderPosTemplate,
//                   height: calmSizeTemplate,
//                   overflow: "hidden",
//                 }
//                 : {
//                   left: sliderPosTemplate,
//                   width: calmSizeTemplate,
//                   overflow: "hidden",
//                 }
//             }
//           >
//             <CalmSide />
//           </motion.div>

//           {/* Slider Indicator */}
//           <motion.div
//             className={`absolute z-20 ${isMobile ? "left-0 right-0 h-0" : "top-0 bottom-0 w-0"
//               }`}
//             style={
//               isMobile ? { top: sliderPosTemplate } : { left: sliderPosTemplate }
//             }
//           >
//             {/* Slider Line */}
//             <div
//               className={`absolute bg-white ${isMobile
//                 ? "left-0 right-0 top-1/2 -translate-y-1/2 h-[2px]"
//                 : "top-0 bottom-0 left-1/2 -translate-x-1/2 w-[2px]"
//                 }`}
//               style={{
//                 boxShadow: "0 0 30px rgba(255, 255, 255, 0.8)",
//               }}
//             />

//             {/* Handle */}
//             <motion.div
//               className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2
//                 w-20 h-20 bg-white rounded-full shadow-2xl 
//                 flex items-center justify-center
//                 cursor-grab active:cursor-grabbing
//                 touch-none"
//               drag={isMobile ? "y" : "x"}
//               dragConstraints={getDragConstraints()}
//               dragElastic={0}
//               dragMomentum={false}
//               onDragStart={() => setIsDragging(true)}
//               onDragEnd={() => setIsDragging(false)}
//               onDrag={handleDrag}
//               whileHover={{ scale: 1.1 }}
//               whileTap={{ scale: 0.95 }}
//             >
//               {/* Arrows */}
//               <svg
//                 width="28"
//                 height="28"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 stroke="currentColor"
//                 strokeWidth="2.5"
//                 className="text-[--color-primary]"
//                 style={{
//                   transform: isMobile ? "rotate(90deg)" : "none",
//                 }}
//               >
//                 <path d="M18 8L22 12L18 16" />
//                 <path d="M6 8L2 12L6 16" />
//               </svg>

//               {/* Hint Text */}
//               <motion.div
//                 className="absolute bg-white px-4 py-2 rounded-full shadow-lg 
//                   whitespace-nowrap pointer-events-none z-30"
//                 style={{
//                   fontSize: "0.875rem",
//                   fontWeight: 500,
//                   color: "#093A5B",
//                   ...(isMobile
//                     ? {
//                       left: "50%",
//                       top: "-5rem",
//                       transform: "translateX(-50%)",
//                       textAlign: "center",
//                     }
//                     : {
//                       top: "50%",
//                       left: "-8rem",
//                       transform: "translateY(-50%)",
//                     }),
//                 }}
//                 initial={{ opacity: 1 }}
//                 animate={{ opacity: isDragging ? 0 : [1, 0.5, 1] }}
//                 transition={{ duration: 2, repeat: isDragging ? 0 : Infinity }}
//               >
//                 {isMobile ? "↑ Drag to compare ↓" : "← Drag to compare →"}
//               </motion.div>
//             </motion.div>
//           </motion.div>

//           {/* Side Indicators */}
//           <div className="absolute bottom-6 left-6 z-10">
//             <motion.div
//               className="bg-black/30 backdrop-blur-sm rounded-full px-4 py-2 border border-white/20"
//               animate={{
//                 opacity: activeSide === "chaos" ? 1 : 0.6,
//                 scale: activeSide === "chaos" ? 1.05 : 1,
//               }}
//               transition={{ duration: 0.3 }}
//             >
//               <span className="text-red-300 font-semibold text-sm">CHAOS</span>
//             </motion.div>
//           </div>

//           <div className="absolute bottom-6 right-6 z-10">
//             <motion.div
//               className="bg-black/30 backdrop-blur-sm rounded-full px-4 py-2 border border-white/20"
//               animate={{
//                 opacity: activeSide === "calm" ? 1 : 0.6,
//                 scale: activeSide === "calm" ? 1.05 : 1,
//               }}
//               transition={{ duration: 0.3 }}
//             >
//               <span className="text-teal-300 font-semibold text-sm">CALM</span>
//             </motion.div>
//           </div>
//         </motion.div>
//       </div>
//     </section>
//   );
// }

// // CHAOS SIDE
// function ChaosSide() {
//   const chaosElements = [
//     { icon: "📧", text: "URGENT!!!", x: 10, y: 12, rotation: -12 },
//     { icon: "💬", text: "47 unread", x: 70, y: 18, rotation: 8 },
//     { icon: "📁", text: "Where?", x: 12, y: 75, rotation: 15 },
//     { icon: "❓", text: "Lost file", x: 75, y: 70, rotation: -18 },
//     { icon: "📱", text: "+99", x: 40, y: 85, rotation: 5 },
//   ];

//   return (
//     <div className="relative w-full h-full flex items-center justify-center px-4 md:px-16">
//       {/* Noise */}
//       <motion.div
//         className="absolute inset-0 opacity-10"
//         style={{
//           backgroundImage:
//             "repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(255,255,255,0.03) 2px, rgba(255,255,255,0.03) 4px)",
//         }}
//         animate={{ backgroundPosition: ["0px 0px", "0px 100px"] }}
//         transition={{ duration: 3, repeat: Infinity, ease: "linear" }}
//       />

//       {/* Floating Chaos Elements */}
//       <div className="absolute inset-0 pointer-events-none">
//         {chaosElements.map((el, idx) => (
//           <motion.div
//             key={idx}
//             className="absolute bg-red-900/30 backdrop-blur-sm border border-red-500/40 rounded-xl p-3"
//             style={{
//               left: `${el.x}%`,
//               top: `${el.y}%`,
//             }}
//             animate={{
//               y: [0, -15, 0],
//               rotate: [el.rotation, el.rotation + 8, el.rotation],
//               opacity: [0.5, 0.8, 0.5],
//             }}
//             transition={{
//               duration: 2.5 + idx * 0.5,
//               repeat: Infinity,
//               ease: "easeInOut",
//             }}
//           >
//             <div className="flex items-center gap-2">
//               <span style={{ fontSize: "1.25rem" }}>{el.icon}</span>
//               <span
//                 className="text-red-300 whitespace-nowrap"
//                 style={{ fontSize: "0.8125rem", fontWeight: 600 }}
//               >
//                 {el.text}
//               </span>
//             </div>
//           </motion.div>
//         ))}
//       </div>

//       {/* Centered Content */}
//       <div className="relative z-10 w-full max-w-sm text-center">
//         <motion.div
//           className="mb-6"
//           animate={{ opacity: [1, 0.7, 1] }}
//           transition={{ duration: 2, repeat: Infinity }}
//         >
//           <div className="flex flex-row justify-center items-center">
//             <div
//               className="text-red-400 mb-4"
//               style={{
//                 fontSize: "1.25rem",
//                 fontWeight: 700,
//                 letterSpacing: "0.12em",
//               }}
//             >
//               THE OLD WAY
//             </div>
//             <div
//               className="text-red-200/60 mb-2"
//               style={{ fontSize: "3.5rem", fontWeight: 300, lineHeight: 1 }}
//             >
//               😵‍💫
//             </div>
//           </div>
//         </motion.div>

//         <div className="bg-black/20 backdrop-blur-sm rounded-xl p-5 border border-red-900/30 mx-auto">
//           <div className="space-y-2.5">
//             {/* Browser Tabs */}
//             <div className="flex gap-1 mb-3 overflow-hidden">
//               {Array.from({ length: 8 }).map((_, i) => (
//                 <motion.div
//                   key={i}
//                   className="h-7 bg-red-900/40 rounded-t flex-1 min-w-0"
//                   animate={{ opacity: [0.3, 0.6, 0.3] }}
//                   transition={{ duration: 1 + i * 0.15, repeat: Infinity }}
//                 />
//               ))}
//             </div>

//             {/* Items */}
//             {[
//               "Multiple apps open",
//               "Lost in threads",
//               "Can't find files",
//               "Working late",
//             ].map((text, i) => (
//               <motion.div
//                 key={i}
//                 className="bg-red-900/20 rounded p-2.5 border-l-2 border-red-500"
//                 animate={{ x: [-1.5, 1.5, -1.5] }}
//                 transition={{ duration: 1.5 + i * 0.25, repeat: Infinity }}
//               >
//                 <div
//                   className="text-red-200/50"
//                   style={{ fontSize: "0.75rem" }}
//                 >
//                   {text}
//                 </div>
//               </motion.div>
//             ))}
//           </div>

//           <motion.div
//             className="mt-5 text-red-400 flex items-center justify-center gap-2"
//             style={{ fontSize: "0.8125rem", fontWeight: 600 }}
//             animate={{ opacity: [1, 0.5, 1] }}
//             transition={{ duration: 1.5, repeat: Infinity }}
//           >
//             <span>🕘</span>
//             <span>Still working at 9:30 PM</span>
//           </motion.div>
//         </div>
//       </div>
//     </div>
//   );
// }

// // CALM SIDE
// function CalmSide() {
//   // floating shapes for the right side (✨, ✓, 🎯)
//   const floatingShapes = [
//     {
//       className:
//         "w-16 h-16 bg-teal-400/20 rounded-full backdrop-blur-sm flex items-center justify-center",
//       style: { top: "15%", left: "15%" },
//       emoji: "✨",
//       fontSize: "2rem",
//     },
//     {
//       className:
//         "w-14 h-14 bg-green-400/20 rounded-lg backdrop-blur-sm flex items-center justify-center",
//       style: { top: "25%", right: "20%" },
//       emoji: "✓",
//       fontSize: "1.75rem",
//     },
//     {
//       className:
//         "w-12 h-12 bg-cyan-400/20 rounded-full backdrop-blur-sm flex items-center justify-center",
//       style: { bottom: "20%", left: "25%" },
//       emoji: "🎯",
//       fontSize: "1.5rem",
//     },
//   ];

//   const dots = [
//     { left: "20%", top: "30%" },
//     { left: "35%", top: "18%" },
//     { left: "55%", top: "26%" },
//     { left: "70%", top: "35%" },
//     { left: "30%", top: "55%" },
//     { left: "50%", top: "65%" },
//     { left: "65%", top: "52%" },
//     { left: "40%", top: "40%" },
//     { left: "80%", top: "48%" },
//   ];

//   return (
//     <div className="relative w-full h-full flex items-center justify-center px-4 md:px-16">
//       {/* Subtle grid */}
//       <div
//         className="absolute inset-0 opacity-5"
//         style={{
//           backgroundImage:
//             "radial-gradient(circle, rgba(255,255,255,0.3) 1px, transparent 1px)",
//           backgroundSize: "30px 30px",
//         }}
//       />

//       {/* Floating shapes + lines + dots */}
//       <div className="absolute inset-0 pointer-events-none">
//         {/* Large floating shapes */}
//         {floatingShapes.map((shape, idx) => (
//           <motion.div
//             key={idx}
//             className={`absolute ${shape.className}`}
//             style={shape.style}
//             animate={{
//               y: [0, -12, 0],
//               scale: [1, 1.08, 1],
//               rotate: idx === 1 ? [0, 4, 0] : 0,
//             }}
//             transition={{
//               duration: 4 + idx,
//               repeat: Infinity,
//               ease: "easeInOut",
//             }}
//           >
//             <span style={{ fontSize: shape.fontSize }}>{shape.emoji}</span>
//           </motion.div>
//         ))}

//         {/* Wavy lines */}
//         <motion.svg
//           className="absolute left-0 right-0"
//           style={{ bottom: "18%", width: "100%", height: "120px" }}
//           viewBox="0 0 500 300"
//         >
//           <motion.path
//             d="M 0,150 Q 250,120 500,150"
//             stroke="#0F9D92"
//             strokeWidth="3"
//             fill="none"
//             strokeLinecap="round"
//             strokeDasharray="4 6"
//             animate={{ strokeDashoffset: [0, -20] }}
//             transition={{ duration: 3, repeat: Infinity, ease: "linear" }}
//           />
//           <motion.path
//             d="M 0,250 Q 250,220 500,250"
//             stroke="#34C759"
//             strokeWidth="3"
//             fill="none"
//             strokeLinecap="round"
//             strokeDasharray="4 6"
//             animate={{ strokeDashoffset: [0, -20] }}
//             transition={{ duration: 4, repeat: Infinity, ease: "linear" }}
//           />
//         </motion.svg>

//         {/* Small glowing dots */}
//         {dots.map((dot, idx) => (
//           <motion.div
//             key={idx}
//             className="absolute w-1.5 h-1.5 bg-teal-300 rounded-full"
//             style={dot}
//             animate={{
//               y: [0, -10, 0],
//               scale: [1, 1.1, 1],
//               opacity: [0.5, 1, 0.5],
//             }}
//             transition={{
//               duration: 2.5 + idx * 0.3,
//               repeat: Infinity,
//               ease: "easeInOut",
//             }}
//           />
//         ))}
//       </div>

//       {/* Centered content */}
//       <div className="relative z-10 w-full max-w-sm text-center">
//         <motion.div
//           className="mb-6"
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.8 }}
//         >
//           <div className="flex flex-row justify-center items-center">
//             <div className=" text-teal-300 mb-4 Simplifyte_Title">
//               THE SIMPLIFYTE WAY
//             </div>
//             <div className="text-teal-100 mb-2 Simplifyte_Emoji">✨</div>
//           </div>
//         </motion.div>

//         <div
//           className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20 mx-auto"
//           style={{ boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)" }}
//         >
//           <div className="space-y-3.5">
//             {[
//               { icon: "✅", text: "All tasks in one view" },
//               { icon: "💬", text: "Conversations in context" },
//               { icon: "📎", text: "Files where you need them" },
//               { icon: "🎯", text: "Everything organized" },
//             ].map((item, i) => (
//               <motion.div
//                 key={i}
//                 className="bg-white/10 rounded-xl p-3.5 border border-white/10 flex items-center gap-3"
//                 initial={{ opacity: 0, x: -20 }}
//                 whileInView={{ opacity: 1, x: 0 }}
//                 viewport={{ once: true }}
//                 transition={{ delay: i * 0.1, duration: 0.5 }}
//               >
//                 <span style={{ fontSize: "1.125rem" }}>{item.icon}</span>
//                 <span
//                   className="text-white/90"
//                   style={{ fontSize: "0.875rem" }}
//                 >
//                   {item.text}
//                 </span>
//               </motion.div>
//             ))}
//           </div>

//           <motion.div
//             className="mt-5 text-teal-300 flex items-center justify-center gap-2"
//             style={{ fontSize: "0.9375rem", fontWeight: 600 }}
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             transition={{ delay: 0.8 }}
//           >
//             <span>🏡</span>
//             <span>Home by 6:00 PM</span>
//           </motion.div>
//         </div>
//       </div>
//     </div>
//   );
// }


// 3 Third Code is there =====================================

// import React, { useRef, useState, useEffect } from "react";
// import { motion } from "motion/react";

// export function Slider() {
//   const containerRef = useRef(null);

//   // start around 53% like Figma
//   const [sliderPosition, setSliderPosition] = useState(53);
//   const [isDragging, setIsDragging] = useState(false);

//   useEffect(() => {
//     const handleMove = (event) => {
//       if (!isDragging || !containerRef.current) return;

//       const rect = containerRef.current.getBoundingClientRect();
//       let clientX;

//       if (event.touches && event.touches[0]) {
//         clientX = event.touches[0].clientX;
//       } else if (event.clientX != null) {
//         clientX = event.clientX;
//       } else {
//         return;
//       }

//       let percentage = ((clientX - rect.left) / rect.width) * 100;
//       percentage = Math.max(0, Math.min(100, percentage));
//       setSliderPosition(percentage);
//     };

//     const stopDrag = () => setIsDragging(false);

//     window.addEventListener("mousemove", handleMove);
//     window.addEventListener("touchmove", handleMove, { passive: false });
//     window.addEventListener("mouseup", stopDrag);
//     window.addEventListener("touchend", stopDrag);

//     return () => {
//       window.removeEventListener("mousemove", handleMove);
//       window.removeEventListener("touchmove", handleMove);
//       window.removeEventListener("mouseup", stopDrag);
//       window.removeEventListener("touchend", stopDrag);
//     };
//   }, [isDragging]);

//   const startDrag = (e) => {
//     e.preventDefault();
//     setIsDragging(true);
//   };

//   const oldItems = [
//     { icon: "🗂️", text: "8 browser tabs always open" },
//     { icon: "📱", text: "WhatsApp messages buried in groups" },
//     { icon: "📧", text: "Lost email threads with clients" },
//     { icon: "❓", text: "Where's that file?" },
//     { icon: "🕘", text: "Still working at 9:30 PM" },
//   ];

//   const newItems = [
//     { icon: "✨", text: "One clean interface" },
//     { icon: "💬", text: "All conversations in context" },
//     { icon: "📎", text: "Files attached to tasks" },
//     { icon: "🎯", text: "Everything exactly where you need it" },
//     { icon: "🏡", text: "Home by 6:00 PM" },
//   ];

//   const calmDots = [
//     { left: "20%", top: "30%" },
//     { left: "30%", top: "50%" },
//     { left: "40%", top: "70%" },
//     { left: "50%", top: "30%" },
//     { left: "60%", top: "50%" },
//     { left: "70%", top: "70%" },
//     { left: "80%", top: "30%" },
//     { left: "90%", top: "50%" },
//   ];

//   return (
//     <section className="py-48 px-5 bg-white">
//       <div className="max-w-[1400px] mx-auto">
//         {/* Header */}
//         <motion.div
//           className="text-center mb-20"
//           initial={{ opacity: 0, y: 30 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           viewport={{ once: true }}
//           transition={{ duration: 0.6 }}
//         >
//           <h2 className="text-[--color-primary] mb-6">
//             The difference is night and day.
//           </h2>
//           <p className="text-[--color-text-secondary]">
//             See how Simplifyte transforms chaotic workflows into calm
//             productivity.
//           </p>
//         </motion.div>

//         {/* Before / After Container */}
//         <div
//           ref={containerRef}
//           className="relative h-[600px] rounded-3xl overflow-hidden"
//           style={{ boxShadow: "0 25px 80px rgba(0,0,0,0.15)" }}
//         >
//           {/* OLD WAY (base) */}
//           <div
//             className="absolute inset-0 flex items-center justify-center overflow-hidden"
//             style={{
//               background:
//                 "linear-gradient(135deg, rgb(45,27,31) 0%, rgb(61,36,40) 100%)",
//               zIndex: 1,
//             }}
//           >
//             {/* chaos shapes */}
//             <motion.div
//               className="absolute top-[10%] left-[10%] w-16 h-16 bg-red-500/20 rounded-lg backdrop-blur-sm flex items-center justify-center"
//               animate={{ y: [10, -10, 10], rotate: [-6, 6, -6] }}
//               transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
//             >
//               <span style={{ fontSize: "2rem" }}>📧</span>
//             </motion.div>

//             <motion.div
//               className="absolute top-[20%] right-[15%] w-20 h-20 bg-orange-500/20 rounded-full backdrop-blur-sm flex items-center justify-center"
//               animate={{ scale: [1, 1.15, 1], rotate: [0, 130, 0] }}
//               transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
//             >
//               <span style={{ fontSize: "2.5rem" }}>📱</span>
//             </motion.div>

//             <motion.div
//               className="absolute bottom-[15%] left-[20%] w-14 h-14 bg-yellow-500/20 rounded-lg backdrop-blur-sm flex items-center justify-center"
//               animate={{ x: [-5, 5, -5], rotate: [6, -6, 6] }}
//               transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
//             >
//               <span style={{ fontSize: "1.75rem" }}>📂</span>
//             </motion.div>

//             <motion.div
//               className="absolute bottom-[25%] right-[10%] w-12 h-12 bg-red-500/20 rounded-full backdrop-blur-sm flex items-center justify-center"
//               animate={{ y: [-8, 8, -8], rotate: [0, -20, 0] }}
//               transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
//             >
//               <span style={{ fontSize: "1.5rem" }}>❗</span>
//             </motion.div>

//             {/* red/orange lines */}
//             <svg className="absolute inset-0 w-full h-full opacity-10">
//               <path
//                 d="M 0,100 Q 200,150 400,100"
//                 stroke="#FF3B30"
//                 strokeWidth="2"
//                 fill="none"
//               />
//               <path
//                 d="M 0,200 Q 250,250 500,200"
//                 stroke="#FF9500"
//                 strokeWidth="2"
//                 fill="none"
//               />
//             </svg>

//             {/* text */}
//             <div className="relative text-center px-12 z-10">
//               <div
//                 className="text-red-400 mb-8"
//                 style={{
//                   fontSize: "1.25rem",
//                   fontWeight: 600,
//                   letterSpacing: "0.1em",
//                 }}
//               >
//                 THE OLD WAY
//               </div>
//               <div className="space-y-5 text-left max-w-md mx-auto">
//                 {oldItems.map((item, idx) => (
//                   <div key={idx}>
//                     <div className="flex items-center gap-4 text-white/80">
//                       <span style={{ fontSize: "1.5rem" }}>{item.icon}</span>
//                       <span
//                         style={{
//                           fontSize: "1.125rem",
//                           fontWeight: 400,
//                         }}
//                       >
//                         {item.text}
//                       </span>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>

//           {/* SIMPLIFYTE WAY (clipped overlay) */}
//           <div
//             className="absolute inset-0 flex items-center justify-center overflow-hidden"
//             style={{
//               background:
//                 "linear-gradient(135deg, rgb(9,58,91) 0%, rgb(10,77,110) 100%)",
//               clipPath: `inset(0 0 0 ${sliderPosition}%)`,
//               zIndex: 2,
//             }}
//           >
//             {/* calm shapes */}
//             <motion.div
//               className="absolute top-[15%] left-[15%] w-16 h-16 bg-teal-400/20 rounded-full backdrop-blur-sm flex items-center justify-center"
//               animate={{ y: [-10, 10, -10], scale: [1, 1.1, 1] }}
//               transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
//             >
//               <span style={{ fontSize: "2rem" }}>✨</span>
//             </motion.div>

//             <motion.div
//               className="absolute top-[25%] right-[20%] w-14 h-14 bg-green-400/20 rounded-lg backdrop-blur-sm flex items-center justify-center"
//               animate={{ y: [-6, 6, -6], rotate: [-4, 4, -4] }}
//               transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
//             >
//               <span style={{ fontSize: "1.75rem" }}>✓</span>
//             </motion.div>

//             <motion.div
//               className="absolute bottom-[20%] left-[25%] w-12 h-12 bg-cyan-400/20 rounded-full backdrop-blur-sm flex items-center justify-center"
//               animate={{ scale: [1, 1.15, 1] }}
//               transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
//             >
//               <span style={{ fontSize: "1.5rem" }}>🎯</span>
//             </motion.div>

//             <motion.div
//               className="absolute bottom-[30%] right-[15%] w-16 h-16 bg-blue-400/20 rounded-lg backdrop-blur-sm flex items-center justify-center"
//               animate={{ y: [5, -5, 5], rotate: [-10, 10, -10] }}
//               transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
//             >
//               <span style={{ fontSize: "2rem" }}>📎</span>
//             </motion.div>

//             {/* teal lines */}
//             <svg className="absolute inset-0 w-full h-full opacity-20">
//               <path
//                 d="M 0,150 Q 250,120 500,150"
//                 stroke="#0F9D92"
//                 strokeWidth="3"
//                 fill="none"
//               />
//               <path
//                 d="M 0,250 Q 250,220 500,250"
//                 stroke="#34C759"
//                 strokeWidth="3"
//                 fill="none"
//               />
//             </svg>

//             {/* dots */}
//             {calmDots.map((dot, idx) => (
//               <motion.div
//                 key={idx}
//                 className="absolute w-1.5 h-1.5 bg-teal-300 rounded-full"
//                 style={dot}
//                 animate={{
//                   y: [-10, 10, -10],
//                   scale: [0.8, 1.05, 0.9],
//                   opacity: [0.6, 1, 0.6],
//                 }}
//                 transition={{
//                   duration: 4 + idx * 0.4,
//                   repeat: Infinity,
//                   ease: "easeInOut",
//                 }}
//               />
//             ))}

//             {/* text */}
//             <div className="relative text-center px-12 z-10">
//               <div
//                 className="text-teal-300 mb-8"
//                 style={{
//                   fontSize: "1.25rem",
//                   fontWeight: 600,
//                   letterSpacing: "0.1em",
//                   textShadow: "0 0 10px rgba(79, 209, 197, 0.3)",
//                 }}
//               >
//                 THE SIMPLIFYTE WAY
//               </div>
//               <div className="space-y-5 text-left max-w-md mx-auto">
//                 {newItems.map((item, idx) => (
//                   <div key={idx}>
//                     <div className="flex items-center gap-4 text-white">
//                       <span style={{ fontSize: "1.5rem" }}>{item.icon}</span>
//                       <span
//                         style={{
//                           fontSize: "1.125rem",
//                           fontWeight: 500,
//                         }}
//                       >
//                         {item.text}
//                       </span>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>

//           {/* SLIDER HANDLE */}
//           <div
//             className="absolute top-0 bottom-0 w-1 bg-white cursor-ew-resize z-20"
//             style={{
//               left: `${sliderPosition}%`,
//               boxShadow: "0 0 20px rgba(255,255,255,0.5)",
//               transform: "translateX(-50%)",
//               userSelect: "none",
//               touchAction: "pan-y",
//             }}
//             onMouseDown={startDrag}
//             onTouchStart={startDrag}
//           >
//             <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-16 h-16 bg-white rounded-full shadow-xl flex items-center justify-center">
//               <svg
//                 width="24"
//                 height="24"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 stroke="currentColor"
//                 strokeWidth="2"
//                 className="text-[--color-primary]"
//               >
//                 <path d="M18 8L22 12L18 16" />
//                 <path d="M6 8L2 12L6 16" />
//               </svg>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }



// import React, { useRef, useState, useEffect } from "react";
// import { motion } from "motion/react";

// export function Slider() {
//   const containerRef = useRef(null);

//   // Start around 53% like Figma
//   const [sliderPosition, setSliderPosition] = useState(53);
//   const [isDragging, setIsDragging] = useState(false);

//   // Handle drag movement (mouse + touch)
//   useEffect(() => {
//     const handleMove = (event) => {
//       if (!isDragging || !containerRef.current) return;

//       const rect = containerRef.current.getBoundingClientRect();
//       let clientX;

//       if (event.touches && event.touches[0]) {
//         clientX = event.touches[0].clientX;
//       } else if (event.clientX != null) {
//         clientX = event.clientX;
//       } else {
//         return;
//       }

//       let percentage = ((clientX - rect.left) / rect.width) * 100;
//       percentage = Math.max(0, Math.min(100, percentage));
//       setSliderPosition(percentage);
//     };

//     const stopDrag = () => setIsDragging(false);

//     window.addEventListener("mousemove", handleMove);
//     window.addEventListener("touchmove", handleMove, { passive: false });
//     window.addEventListener("mouseup", stopDrag);
//     window.addEventListener("touchend", stopDrag);

//     return () => {
//       window.removeEventListener("mousemove", handleMove);
//       window.removeEventListener("touchmove", handleMove);
//       window.removeEventListener("mouseup", stopDrag);
//       window.removeEventListener("touchend", stopDrag);
//     };
//   }, [isDragging]);

//   const startDrag = (e) => {
//     e.preventDefault();
//     setIsDragging(true);
//   };

//   // “Table” bullets like your old layout
//   const oldItems = [
//     "8 browser tabs always open",
//     "WhatsApp messages buried in groups",
//     "Lost email threads with clients",
//     "Where's that file?",
//     "Still working at 9:30 PM",
//   ];

//   const newItems = [
//     "One clean interface",
//     "All conversations in context",
//     "Files attached to tasks",
//     "Everything exactly where you need it",
//     "Home by 6:00 PM",
//   ];

//   // Calm dots positions
//   const calmDots = [
//     { left: "20%", top: "30%" },
//     { left: "30%", top: "50%" },
//     { left: "40%", top: "70%" },
//     { left: "50%", top: "30%" },
//     { left: "60%", top: "50%" },
//     { left: "70%", top: "70%" },
//     { left: "80%", top: "30%" },
//     { left: "90%", top: "50%" },
//   ];

//   return (
//     <section className="py-48 px-5 bg-white">
//       <div className="max-w-[1400px] mx-auto">
//         {/* Header */}
//         <motion.div
//           className="text-center mb-20"
//           initial={{ opacity: 0, y: 30 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           viewport={{ once: true }}
//           transition={{ duration: 0.6 }}
//         >
//           <h2 className="text-[--color-primary] mb-6">
//             The difference is night and day.
//           </h2>
//           <p className="text-[--color-text-secondary]">
//             See how Simplifyte transforms chaotic workflows into calm
//             productivity.
//           </p>
//         </motion.div>

//         {/* Before / After Container */}
//         <div
//           ref={containerRef}
//           className="relative h-[600px] rounded-3xl overflow-hidden"
//           style={{ boxShadow: "0 25px 80px rgba(0,0,0,0.15)" }}
//         >
//           {/* ========= LEFT: THE OLD WAY (base) ========= */}
//           <div
//             className="absolute inset-0 flex items-center justify-center overflow-hidden"
//             style={{
//               background:
//                 "linear-gradient(135deg, rgb(45,27,31) 0%, rgb(61,36,40) 100%)",
//               zIndex: 1,
//             }}
//           >
//             {/* Floating chaos shapes */}
//             <motion.div
//               className="absolute top-[10%] left-[10%] w-16 h-16 bg-red-500/20 rounded-lg backdrop-blur-sm flex items-center justify-center"
//               animate={{ y: [10, -10, 10], rotate: [-6, 6, -6] }}
//               transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
//             >
//               <span style={{ fontSize: "2rem" }}>📧</span>
//             </motion.div>

//             <motion.div
//               className="absolute top-[20%] right-[15%] w-20 h-20 bg-orange-500/20 rounded-full backdrop-blur-sm flex items-center justify-center"
//               animate={{ scale: [1, 1.15, 1], rotate: [0, 130, 0] }}
//               transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
//             >
//               <span style={{ fontSize: "2.5rem" }}>📱</span>
//             </motion.div>

//             <motion.div
//               className="absolute bottom-[15%] left-[20%] w-14 h-14 bg-yellow-500/20 rounded-lg backdrop-blur-sm flex items-center justify-center"
//               animate={{ x: [-5, 5, -5], rotate: [6, -6, 6] }}
//               transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
//             >
//               <span style={{ fontSize: "1.75rem" }}>📂</span>
//             </motion.div>

//             <motion.div
//               className="absolute bottom-[25%] right-[10%] w-12 h-12 bg-red-500/20 rounded-full backdrop-blur-sm flex items-center justify-center"
//               animate={{ y: [-8, 8, -8], rotate: [0, -20, 0] }}
//               transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
//             >
//               <span style={{ fontSize: "1.5rem" }}>❗</span>
//             </motion.div>

//             {/* Red / Orange wavy lines with smooth dash animation */}
//             <svg className="absolute inset-0 w-full h-full opacity-15">
//               {/* <motion.path
//                 d="M 0,100 Q 200,150 400,100"
//                 stroke="#FF3B30"
//                 strokeWidth="2"
//                 fill="none"
//                 strokeDasharray="2 6"
//                 animate={{ strokeDashoffset: [0, -20] }}
//                 transition={{
//                   duration: 6,
//                   repeat: Infinity,
//                   ease: "linear",
//                 }}
//               /> */}
//               <motion.path
//                 d="M 0,150 Q 250,120 500,150"
//                 stroke="#0F9D92"
//                 strokeWidth="3"
//                 fill="none"
//                 strokeDasharray="0.6 1"          // ✅ dot dot like Figma
//                 opacity={0.6}
//                 pathLength={1}
//                 animate={{ strokeDashoffset: [0, -1] }}   // small movement so it doesn't vanish
//                 transition={{
//                   duration: 4,
//                   repeat: Infinity,
//                   ease: "linear",
//                 }}
//               />
//               {/* <motion.path
//                 d="M 0,200 Q 250,250 500,200"
//                 stroke="#FF9500"
//                 strokeWidth="2"
//                 fill="none"
//                 strokeDasharray="2 6"
//                 animate={{ strokeDashoffset: [0, -20] }}
//                 transition={{
//                   duration: 7,
//                   repeat: Infinity,
//                   ease: "linear",
//                 }}
//               /> */}
//               <motion.path
//                 d="M 0,250 Q 250,220 500,250"
//                 stroke="#34C759"
//                 strokeWidth="3"
//                 fill="none"
//                 strokeDasharray="0.48 1"        // from your 0.4776px 1px
//                 opacity={0.48}
//                 pathLength={1}
//                 animate={{ strokeDashoffset: [0, -1] }}
//                 transition={{
//                   duration: 4.5,
//                   repeat: Infinity,
//                   ease: "linear",
//                 }}
//               />
//             </svg>

//             {/* OLD WAY content – card/table style like your old ChaosSide */}
//             <div className="relative z-10 w-full max-w-sm text-center px-4 md:px-0">
//               <motion.div
//                 className="mb-6"
//                 animate={{ opacity: [1, 0.7, 1] }}
//                 transition={{ duration: 2, repeat: Infinity }}
//               >
//                 <div className="flex flex-row justify-center items-center gap-3">
//                   <div
//                     className="text-red-400 mb-4"
//                     style={{
//                       fontSize: "1.25rem",
//                       fontWeight: 700,
//                       letterSpacing: "0.12em",
//                     }}
//                   >
//                     THE OLD WAY
//                   </div>
//                   <div
//                     className="text-red-200/60 mb-2"
//                     style={{ fontSize: "3.5rem", fontWeight: 300, lineHeight: 1 }}
//                   >
//                     😵‍💫
//                   </div>
//                 </div>
//               </motion.div>

//               <div className="bg-black/20 backdrop-blur-sm rounded-xl p-5 border border-red-900/30 mx-auto">
//                 <div className="space-y-2.5">
//                   {/* fake browser tabs row */}
//                   <div className="flex gap-1 mb-3 overflow-hidden">
//                     {Array.from({ length: 8 }).map((_, i) => (
//                       <motion.div
//                         key={i}
//                         className="h-7 bg-red-900/40 rounded-t flex-1 min-w-0"
//                         animate={{ opacity: [0.3, 0.6, 0.3] }}
//                         transition={{
//                           duration: 1 + i * 0.15,
//                           repeat: Infinity,
//                         }}
//                       />
//                     ))}
//                   </div>

//                   {/* bullet items in cards */}
//                   {oldItems.map((text, i) => (
//                     <motion.div
//                       key={i}
//                       className="bg-red-900/20 rounded p-2.5 border-l-2 border-red-500"
//                       animate={{ x: [-1.5, 1.5, -1.5] }}
//                       transition={{
//                         duration: 1.5 + i * 0.25,
//                         repeat: Infinity,
//                       }}
//                     >
//                       <div
//                         className="text-red-200/80"
//                         style={{ fontSize: "0.85rem" }}
//                       >
//                         {text}
//                       </div>
//                     </motion.div>
//                   ))}
//                 </div>

//                 <motion.div
//                   className="mt-5 text-red-400 flex items-center justify-center gap-2"
//                   style={{ fontSize: "0.8125rem", fontWeight: 600 }}
//                   animate={{ opacity: [1, 0.5, 1] }}
//                   transition={{ duration: 1.5, repeat: Infinity }}
//                 >
//                   <span>🕘</span>
//                   <span>Still working at 9:30 PM</span>
//                 </motion.div>
//               </div>
//             </div>
//           </div>

//           {/* ========= RIGHT: THE SIMPLIFYTE WAY (overlay, clip with slider) ========= */}
//           <div
//             className="absolute inset-0 flex items-center justify-center overflow-hidden"
//             style={{
//               background:
//                 "linear-gradient(135deg, rgb(9,58,91) 0%, rgb(10,77,110) 100%)",
//               clipPath: `inset(0 0 0 ${sliderPosition}%)`,
//               zIndex: 2,
//             }}
//           >
//             {/* Calm floating shapes */}
//             <motion.div
//               className="absolute top-[15%] left-[15%] w-16 h-16 bg-teal-400/20 rounded-full backdrop-blur-sm flex items-center justify-center"
//               animate={{ y: [-10, 10, -10], scale: [1, 1.1, 1] }}
//               transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
//             >
//               <span style={{ fontSize: "2rem" }}>✨</span>
//             </motion.div>

//             <motion.div
//               className="absolute top-[25%] right-[20%] w-14 h-14 bg-green-400/20 rounded-lg backdrop-blur-sm flex items-center justify-center"
//               animate={{ y: [-6, 6, -6], rotate: [-4, 4, -4] }}
//               transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
//             >
//               <span style={{ fontSize: "1.75rem" }}>✓</span>
//             </motion.div>

//             <motion.div
//               className="absolute bottom-[20%] left-[25%] w-12 h-12 bg-cyan-400/20 rounded-full backdrop-blur-sm flex items-center justify-center"
//               animate={{ scale: [1, 1.15, 1] }}
//               transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
//             >
//               <span style={{ fontSize: "1.5rem" }}>🎯</span>
//             </motion.div>

//             <motion.div
//               className="absolute bottom-[30%] right-[15%] w-16 h-16 bg-blue-400/20 rounded-lg backdrop-blur-sm flex items-center justify-center"
//               animate={{ y: [5, -5, 5], rotate: [-10, 10, -10] }}
//               transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
//             >
//               <span style={{ fontSize: "2rem" }}>📎</span>
//             </motion.div>

//             {/* Teal / Green wavy lines – smooth continuous animation */}
//             <svg className="absolute inset-0 w-full h-full opacity-20">
//               {/* <motion.path
//                 d="M 0,150 Q 250,120 500,150"
//                 stroke="#0F9D92"
//                 strokeWidth="3"
//                 fill="none"
//                 strokeDasharray="2 6"
//                 animate={{ strokeDashoffset: [0, -20] }}
//                 transition={{
//                   duration: 6,
//                   repeat: Infinity,
//                   ease: "linear",
//                 }}
//               /> */}
//               <motion.path
//                 d="M 0,150 Q 250,120 500,150"
//                 stroke="#0F9D92"
//                 strokeWidth="3"
//                 fill="none"
//                 strokeDasharray="0.6 1"          // ✅ dot dot like Figma
//                 opacity={0.6}
//                 pathLength={1}
//                 animate={{ strokeDashoffset: [0, -1] }}   // small movement so it doesn't vanish
//                 transition={{
//                   duration: 4,
//                   repeat: Infinity,
//                   ease: "linear",
//                 }}
//               />
//               <motion.path
//                 d="M 0,250 Q 250,220 500,250"
//                 stroke="#34C759"
//                 strokeWidth="3"
//                 fill="none"
//                 strokeDasharray="0.48 1"        // from your 0.4776px 1px
//                 opacity={0.48}
//                 pathLength={1}
//                 animate={{ strokeDashoffset: [0, -1] }}
//                 transition={{
//                   duration: 4.5,
//                   repeat: Infinity,
//                   ease: "linear",
//                 }}
//               />
//               {/* <motion.path
//                 d="M 0,250 Q 250,220 500,250"
//                 stroke="#34C759"
//                 strokeWidth="3"
//                 fill="none"
//                 strokeDasharray="2 6"
//                 animate={{ strokeDashoffset: [0, -20] }}
//                 transition={{
//                   duration: 7,
//                   repeat: Infinity,
//                   ease: "linear",
//                 }}
//               /> */}
//               <motion.path
//                 d="M 0,250 Q 250,220 500,250"
//                 stroke="#34C759"
//                 strokeWidth="3"
//                 fill="none"
//                 strokeDasharray="0.48 1"        // from your 0.4776px 1px
//                 opacity={0.48}
//                 pathLength={1}
//                 animate={{ strokeDashoffset: [0, -1] }}
//                 transition={{
//                   duration: 4.5,
//                   repeat: Infinity,
//                   ease: "linear",
//                 }}
//               />
//             </svg>

//             {/* Dots – go UP and vanish */}
//             {calmDots.map((dot, idx) => (
//               <motion.div
//                 key={idx}
//                 className="absolute w-1.5 h-1.5 bg-teal-300 rounded-full"
//                 style={dot}
//                 animate={{
//                   y: [0, -25],
//                   opacity: [0, 1, 0],
//                 }}
//                 transition={{
//                   duration: 3 + idx * 0.3,
//                   repeat: Infinity,
//                   ease: "easeOut",
//                 }}
//               />
//             ))}

//             {/* SIMPLIFYTE content – card/table layout like your old CalmSide */}
//             <div className="relative z-10 w-full max-w-sm text-center px-4 md:px-0">
//               <motion.div
//                 className="mb-6"
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.8 }}
//               >
//                 <div className="flex flex-row justify-center items-center gap-3">
//                   <div className="text-teal-300 mb-4 Simplifyte_Title">
//                     THE SIMPLIFYTE WAY
//                   </div>
//                   <div className="text-teal-100 mb-2 Simplifyte_Emoji">✨</div>
//                 </div>
//               </motion.div>

//               <div
//                 className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20 mx-auto"
//                 style={{ boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)" }}
//               >
//                 <div className="space-y-3.5">
//                   {newItems.map((text, i) => (
//                     <motion.div
//                       key={i}
//                       className="bg-white/10 rounded-xl p-3.5 border border-white/10 flex items-center gap-3"
//                       initial={{ opacity: 0, x: -20 }}
//                       whileInView={{ opacity: 1, x: 0 }}
//                       viewport={{ once: true }}
//                       transition={{ delay: i * 0.1, duration: 0.5 }}
//                     >
//                       <span style={{ fontSize: "1.125rem" }}>
//                         {["✨", "💬", "📎", "🎯", "🏡"][i]}
//                       </span>
//                       <span
//                         className="text-white/90"
//                         style={{ fontSize: "0.875rem" }}
//                       >
//                         {text}
//                       </span>
//                     </motion.div>
//                   ))}
//                 </div>

//                 <motion.div
//                   className="mt-5 text-teal-300 flex items-center justify-center gap-2"
//                   style={{ fontSize: "0.9375rem", fontWeight: 600 }}
//                   initial={{ opacity: 0 }}
//                   animate={{ opacity: 1 }}
//                   transition={{ delay: 0.8 }}
//                 >
//                   <span>🏡</span>
//                   <span>Home by 6:00 PM</span>
//                 </motion.div>
//               </div>
//             </div>
//           </div>

//           {/* ========= SLIDER HANDLE ========= */}
//           <div
//             className="absolute top-0 bottom-0 w-1 bg-white cursor-ew-resize z-20"
//             style={{
//               left: `${sliderPosition}%`,
//               boxShadow: "0 0 20px rgba(255,255,255,0.5)",
//               transform: "translateX(-50%)",
//               userSelect: "none",
//               touchAction: "pan-y",
//             }}
//             onMouseDown={startDrag}
//             onTouchStart={startDrag}
//           >
//             <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-16 h-16 bg-white rounded-full shadow-xl flex items-center justify-center">
//               <svg
//                 width="24"
//                 height="24"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 stroke="currentColor"
//                 strokeWidth="2"
//                 className="text-[--color-primary]"
//               >
//                 <path d="M18 8L22 12L18 16" />
//                 <path d="M6 8L2 12L6 16" />
//               </svg>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }
import React, { useRef, useState, useEffect } from "react";
import { motion, useScroll, useTransform } from "motion/react";

export function Slider() {
  const sectionRef = useRef(null);
  const containerRef = useRef(null);

  // Start around 53% like Figma
  const [sliderPosition, setSliderPosition] = useState(53);
  const [isDragging, setIsDragging] = useState(false);

  // 🔹 1) SCROLL → SLIDER POSITION
  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start end", "end start"], // when section enters/leaves viewport
  });

  // Map scroll (0–1) → slider position (10–90)
  const scrollSlider = useTransform(scrollYProgress, [0.2, 0.8], [10, 90]);

  // When NOT dragging, let scroll control the slider
  useEffect(() => {
    const unsubscribe = scrollSlider.on("change", (latest) => {
      if (!isDragging) {
        setSliderPosition(latest);
      }
    });
    return unsubscribe;
  }, [isDragging, scrollSlider]);

  // 🔹 2) DRAG HANDLING (mouse + touch)
  useEffect(() => {
    const handleMove = (event) => {
      if (!isDragging || !containerRef.current) return;

      const rect = containerRef.current.getBoundingClientRect();
      let clientX;

      if (event.touches && event.touches[0]) {
        clientX = event.touches[0].clientX;
      } else if (event.clientX != null) {
        clientX = event.clientX;
      } else {
        return;
      }

      let percentage = ((clientX - rect.left) / rect.width) * 100;
      percentage = Math.max(0, Math.min(100, percentage));
      setSliderPosition(percentage);
    };

    const stopDrag = () => setIsDragging(false);

    window.addEventListener("mousemove", handleMove);
    window.addEventListener("touchmove", handleMove, { passive: false });
    window.addEventListener("mouseup", stopDrag);
    window.addEventListener("touchend", stopDrag);

    return () => {
      window.removeEventListener("mousemove", handleMove);
      window.removeEventListener("touchmove", handleMove);
      window.removeEventListener("mouseup", stopDrag);
      window.removeEventListener("touchend", stopDrag);
    };
  }, [isDragging]);

  const startDrag = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  // “Table” bullets like your old layout
  const oldItems = [
    "8 browser tabs always open",
    "WhatsApp messages buried in groups",
    "Lost email threads with clients",
    "Where's that file?",
    "Still working at 9:30 PM",
  ];

  const newItems = [
    "One clean interface",
    "All conversations in context",
    "Files attached to tasks",
    "Everything exactly where you need it",
    "Home by 6:00 PM",
  ];

  // Calm dots positions
  const calmDots = [
    { left: "20%", top: "30%" },
    { left: "30%", top: "50%" },
    { left: "40%", top: "70%" },
    { left: "50%", top: "30%" },
    { left: "60%", top: "50%" },
    { left: "70%", top: "70%" },
    { left: "80%", top: "30%" },
    { left: "90%", top: "50%" },
  ];

  return (
    <section ref={sectionRef} className="py-48 px-5 bg-white">
      <div className="max-w-[1400px] mx-auto">
        {/* Header */}
        <motion.div
          className="text-center mb-20"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-[--color-primary] mb-6">
            The difference is night and day.
          </h2>
          <p className="text-[--color-text-secondary]">
            See how Simplifyte transforms chaotic workflows into calm
            productivity.
          </p>
        </motion.div>

        {/* Before / After Container */}
        <div
          ref={containerRef}
          className="relative h-[600px] rounded-3xl overflow-hidden"
          style={{ boxShadow: "0 25px 80px rgba(0,0,0,0.15)" }}
        >
          {/* ========= LEFT: THE OLD WAY (base) ========= */}
          <div
            className="absolute inset-0 flex items-center justify-center overflow-hidden"
            style={{
              background:
                "linear-gradient(135deg, rgb(45,27,31) 0%, rgb(61,36,40) 100%)",
              zIndex: 1,
            }}
          >
            {/* Floating chaos shapes */}
            <motion.div
              className="absolute top-[10%] left-[10%] w-16 h-16 bg-red-500/20 rounded-lg backdrop-blur-sm flex items-center justify-center"
              animate={{ y: [10, -10, 10], rotate: [-6, 6, -6] }}
              transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
            >
              <span style={{ fontSize: "2rem" }}>📧</span>
            </motion.div>

            <motion.div
              className="absolute top-[20%] right-[15%] w-20 h-20 bg-orange-500/20 rounded-full backdrop-blur-sm flex items-center justify-center"
              animate={{ scale: [1, 1.15, 1], rotate: [0, 130, 0] }}
              transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
            >
              <span style={{ fontSize: "2.5rem" }}>📱</span>
            </motion.div>

            <motion.div
              className="absolute bottom-[15%] left-[20%] w-14 h-14 bg-yellow-500/20 rounded-lg backdrop-blur-sm flex items-center justify-center"
              animate={{ x: [-5, 5, -5], rotate: [6, -6, 6] }}
              transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
            >
              <span style={{ fontSize: "1.75rem" }}>📂</span>
            </motion.div>

            <motion.div
              className="absolute bottom-[25%] right-[10%] w-12 h-12 bg-red-500/20 rounded-full backdrop-blur-sm flex items-center justify-center"
              animate={{ y: [-8, 8, -8], rotate: [0, -20, 0] }}
              transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
            >
              <span style={{ fontSize: "1.5rem" }}>❗</span>
            </motion.div>

            {/* Red / Orange / your teal-green lines */}
            <svg className="absolute inset-0 w-full h-full opacity-15">
              <motion.path
                d="M 0,150 Q 250,120 500,150"
                stroke="#0F9D92"
                strokeWidth="3"
                fill="none"
                strokeDasharray="0.6 1"
                opacity={0.6}
                pathLength={1}
                animate={{ strokeDashoffset: [0, -1] }}
                transition={{
                  duration: 4,
                  repeat: Infinity,
                  ease: "linear",
                }}
              />
              <motion.path
                d="M 0,250 Q 250,220 500,250"
                stroke="#34C759"
                strokeWidth="3"
                fill="none"
                strokeDasharray="0.48 1"
                opacity={0.48}
                pathLength={1}
                animate={{ strokeDashoffset: [0, -1] }}
                transition={{
                  duration: 4.5,
                  repeat: Infinity,
                  ease: "linear",
                }}
              />
            </svg>

            {/* OLD WAY content – structured like your “table” */}
            <div className="relative z-10 w-full max-w-sm text-center px-4 md:px-0">
              <motion.div
                className="mb-6"
                animate={{ opacity: [1, 0.7, 1] }}
                transition={{ duration: 2, repeat: Infinity }}
              >
                <div className="flex flex-row justify-center items-center gap-3">
                  <div
                    className="text-red-400 mb-4"
                    style={{
                      fontSize: "1.25rem",
                      fontWeight: 700,
                      letterSpacing: "0.12em",
                    }}
                  >
                    THE OLD WAY
                  </div>
                  <div
                    className="text-red-200/60 mb-2"
                    style={{
                      fontSize: "3.5rem",
                      fontWeight: 300,
                      lineHeight: 1,
                    }}
                  >
                    😵‍💫
                  </div>
                </div>
              </motion.div>

              <div className="bg-black/20 backdrop-blur-sm rounded-xl p-5 border border-red-900/30 mx-auto">
                <div className="space-y-2.5">
                  {/* fake browser tabs row */}
                  <div className="flex gap-1 mb-3 overflow-hidden">
                    {Array.from({ length: 8 }).map((_, i) => (
                      <motion.div
                        key={i}
                        className="h-7 bg-red-900/40 rounded-t flex-1 min-w-0"
                        animate={{ opacity: [0.3, 0.6, 0.3] }}
                        transition={{
                          duration: 1 + i * 0.15,
                          repeat: Infinity,
                        }}
                      />
                    ))}
                  </div>

                  {/* bullet items */}
                  {oldItems.map((text, i) => (
                    <motion.div
                      key={i}
                      className="bg-red-900/20 rounded p-2.5 border-l-2 border-red-500"
                      animate={{ x: [-1.5, 1.5, -1.5] }}
                      transition={{
                        duration: 1.5 + i * 0.25,
                        repeat: Infinity,
                      }}
                    >
                      <div
                        className="text-red-200/80"
                        style={{ fontSize: "0.85rem" }}
                      >
                        {text}
                      </div>
                    </motion.div>
                  ))}
                </div>

                <motion.div
                  className="mt-5 text-red-400 flex items-center justify-center gap-2"
                  style={{ fontSize: "0.8125rem", fontWeight: 600 }}
                  animate={{ opacity: [1, 0.5, 1] }}
                  transition={{ duration: 1.5, repeat: Infinity }}
                >
                  <span>🕘</span>
                  <span>Still working at 9:30 PM</span>
                </motion.div>
              </div>
            </div>
          </div>

          {/* ========= RIGHT: THE SIMPLIFYTE WAY (overlay, clipped by slider) ========= */}
          <div
            className="absolute inset-0 flex items-center justify-center overflow-hidden"
            style={{
              background:
                "linear-gradient(135deg, rgb(9,58,91) 0%, rgb(10,77,110) 100%)",
              clipPath: `inset(0 0 0 ${sliderPosition}%)`,
              zIndex: 2,
            }}
          >
            {/* Calm floating shapes */}
            <motion.div
              className="absolute top-[15%] left-[15%] w-16 h-16 bg-teal-400/20 rounded-full backdrop-blur-sm flex items-center justify-center"
              animate={{ y: [-10, 10, -10], scale: [1, 1.1, 1] }}
              transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
            >
              <span style={{ fontSize: "2rem" }}>✨</span>
            </motion.div>

            <motion.div
              className="absolute top-[25%] right-[20%] w-14 h-14 bg-green-400/20 rounded-lg backdrop-blur-sm flex items-center justify-center"
              animate={{ y: [-6, 6, -6], rotate: [-4, 4, -4] }}
              transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
            >
              <span style={{ fontSize: "1.75rem" }}>✓</span>
            </motion.div>

            <motion.div
              className="absolute bottom-[20%] left-[25%] w-12 h-12 bg-cyan-400/20 rounded-full backdrop-blur-sm flex items-center justify-center"
              animate={{ scale: [1, 1.15, 1] }}
              transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
            >
              <span style={{ fontSize: "1.5rem" }}>🎯</span>
            </motion.div>

            <motion.div
              className="absolute bottom-[30%] right-[15%] w-16 h-16 bg-blue-400/20 rounded-lg backdrop-blur-sm flex items-center justify-center"
              animate={{ y: [5, -5, 5], rotate: [-10, 10, -10] }}
              transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
            >
              <span style={{ fontSize: "2rem" }}>📎</span>
            </motion.div>

            {/* Teal / Green wavy lines */}
            <svg className="absolute inset-0 w-full h-full opacity-20">
              <motion.path
                d="M 0,150 Q 250,120 500,150"
                stroke="#0F9D92"
                strokeWidth="3"
                fill="none"
                strokeDasharray="0.6 1"
                opacity={0.6}
                pathLength={1}
                animate={{ strokeDashoffset: [0, -1] }}
                transition={{
                  duration: 4,
                  repeat: Infinity,
                  ease: "linear",
                }}
              />
              <motion.path
                d="M 0,250 Q 250,220 500,250"
                stroke="#34C759"
                strokeWidth="3"
                fill="none"
                strokeDasharray="0.48 1"
                opacity={0.48}
                pathLength={1}
                animate={{ strokeDashoffset: [0, -1] }}
                transition={{
                  duration: 4.5,
                  repeat: Infinity,
                  ease: "linear",
                }}
              />
            </svg>

            {/* Dots – go UP and vanish */}
            {calmDots.map((dot, idx) => (
              <motion.div
                key={idx}
                className="absolute w-1.5 h-1.5 bg-teal-300 rounded-full"
                style={dot}
                animate={{
                  y: [0, -25],
                  opacity: [0, 1, 0],
                }}
                transition={{
                  duration: 3 + idx * 0.3,
                  repeat: Infinity,
                  ease: "easeOut",
                }}
              />
            ))}

            {/* SIMPLIFYTE content – clean table-like layout */}
            <div className="relative z-10 w-full max-w-sm text-center px-4 md:px-0">
              <motion.div
                className="mb-6"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
              >
                <div className="flex flex-row justify-center items-center gap-3">
                  <div className="text-teal-300 mb-4 Simplifyte_Title">
                    THE SIMPLIFYTE WAY
                  </div>
                  <div className="text-teal-100 mb-2 Simplifyte_Emoji">✨</div>
                </div>
              </motion.div>

              <div
                className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20 mx-auto"
                style={{ boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)" }}
              >
                <div className="space-y-3.5">
                  {newItems.map((text, i) => (
                    <motion.div
                      key={i}
                      className="bg-white/10 rounded-xl p-3.5 border border-white/10 flex items-center gap-3"
                      initial={{ opacity: 0, x: -20 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      viewport={{ once: true }}
                      transition={{ delay: i * 0.1, duration: 0.5 }}
                    >
                      <span style={{ fontSize: "1.125rem" }}>
                        {["✨", "💬", "📎", "🎯", "🏡"][i]}
                      </span>
                      <span
                        className="text-white/90"
                        style={{ fontSize: "0.875rem" }}
                      >
                        {text}
                      </span>
                    </motion.div>
                  ))}
                </div>

                <motion.div
                  className="mt-5 text-teal-300 flex items-center justify-center gap-2"
                  style={{ fontSize: "0.9375rem", fontWeight: 600 }}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.8 }}
                >
                  <span>🏡</span>
                  <span>Home by 6:00 PM</span>
                </motion.div>
              </div>
            </div>
          </div>

          {/* ========= SLIDER HANDLE ========= */}
          <div
            className="absolute top-0 bottom-0 w-1 bg-white cursor-ew-resize z-20"
            style={{
              left: `${sliderPosition}%`,
              boxShadow: "0 0 20px rgba(255,255,255,0.5)",
              transform: "translateX(-50%)",
              userSelect: "none",
              touchAction: "pan-y",
            }}
            onMouseDown={startDrag}
            onTouchStart={startDrag}
          >
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-16 h-16 bg-white rounded-full shadow-xl flex items-center justify-center">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                className="text-[--color-primary]"
              >
                <path d="M18 8L22 12L18 16" />
                <path d="M6 8L2 12L6 16" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
